module.exports = __webpack_public_path__ + "static/media/icon_y_pop_up.59f630ef.svg";